<template>
<div
  v-html="compiledMarkdown"
  class="markdown-div">
</div>
</template>

<script>
import Marked from 'marked';

export default {
  name: 'MarkdownDiv',
  components: { },
  props: {
    text: {
      type: String,
    },
    title: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    compiledMarkdown() {
      var txt = this.text || this.placeholder;
      if (txt || this.title) {
        if(this.title){
          return Marked(`**${this.title}** ${txt}`, { sanitize: true });
        } else {
          return Marked(txt, { sanitize: true });
        }
      }
      return this.placeholder;
    },
  },
  methods: {  },
};
</script>

<style lang="scss">
@import '~@/styles/variables';
.markdown-div {

}
</style>
